import React from 'react';
import PropTypes from 'prop-types';
import css from './RadioOptionLabel.css';

export default class RadioOptionLabel extends React.Component {
  render() {    
    return <label htmlFor={this.props.htmlFor} className={css['label']}>{this.props.text}</label>;
  }
}

RadioOptionLabel.propTypes = {
  text: PropTypes.string.isRequired,
  htmlFor: PropTypes.string.isRequired
};
